"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterInputItemToJSON = exports.FilterInputItemFromJSONTyped = exports.FilterInputItemFromJSON = exports.instanceOfFilterInputItem = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the FilterInputItem interface.
 */
function instanceOfFilterInputItem(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfFilterInputItem = instanceOfFilterInputItem;
function FilterInputItemFromJSON(json) {
    return FilterInputItemFromJSONTyped(json, false);
}
exports.FilterInputItemFromJSON = FilterInputItemFromJSON;
function FilterInputItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'filterName': !(0, runtime_1.exists)(json, 'filterName') ? undefined : json['filterName'],
    };
}
exports.FilterInputItemFromJSONTyped = FilterInputItemFromJSONTyped;
function FilterInputItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'filterName': value.filterName,
    };
}
exports.FilterInputItemToJSON = FilterInputItemToJSON;
